import axios from "axios";
import { AppThunk } from "../../../config/store";
import { authenticatedUserApi } from "../../../config/api";
import { IErrorMessage } from "@advapacs/common";
import { ISessions, ProfileAction } from "./profileSlice";

export interface UpdatePasswordForm {
  currentPassword: string;
  password: string;
  confirmPassword: string;
}

export interface UserSettingNotification {
  onPreliminaryReport?: boolean;
  onFinalReport?: boolean;
  onUpdatedReport?: boolean;
  onReferredCriticalResult?: boolean;
  onCopiedToCriticalResult?: boolean;
}

export const updatePassword =
  (updatePasswordForm: UpdatePasswordForm): AppThunk =>
  async (dispatch) => {
    try {
      dispatch(ProfileAction.updatePasswordStart());
      await axios.post(
        authenticatedUserApi.UPDATE_PASSWORD,
        updatePasswordForm
      );
      dispatch(ProfileAction.updatePasswordSuccess());
    } catch (err) {
      dispatch(
        ProfileAction.updatePasswordFail(err.response.data as IErrorMessage)
      );
    }
  };

export const getUserSettingNotification = (): AppThunk => async (dispatch) => {
  try {
    dispatch(ProfileAction.getUserSettingNotificationStart());
    const response = await axios.get("/users/settings/notifications");
    dispatch(
      ProfileAction.getUserSettingNotificationSuccess(
        response.data as UserSettingNotification
      )
    );
  } catch (err) {
    dispatch(
      ProfileAction.getUserSettingNotificationFail(
        err.response.data as IErrorMessage
      )
    );
  }
};

export const updateUserSettingNotification =
  (data: UserSettingNotification): AppThunk =>
  async (dispatch) => {
    try {
      dispatch(ProfileAction.updateUserSettingNotificationStart());
      await axios.post("/users/settings/notifications", data);
      dispatch(ProfileAction.updateUserSettingNotificationSuccess());
    } catch (err) {
      dispatch(
        ProfileAction.updateUserSettingNotificationFail(
          err.response.data as IErrorMessage
        )
      );
    }
  };

export const getSessions = (): AppThunk => async (dispatch) => {
  dispatch(ProfileAction.getActiveSessionsStart());
  const composedUrl = `${authenticatedUserApi.GET_SESSIONS}`;
  try {
    const response = await axios.get(composedUrl);
    dispatch(
      ProfileAction.getActiveSessionsSuccess(
        response.data.content as Array<ISessions>
      )
    );
  } catch (err) {
    dispatch(ProfileAction.getActiveSessionsFail());
  }
};
